import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  display: grid;
  grid-template:
    'header header'
    'hoursPack statusControl'
    'services services' 1fr
    / 1fr 1fr;
  gap: 1.5rem;
  width: 100%;

  legend {
    font-size: 1rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors[900]};
    margin-bottom: 1rem;
  }
`;
